import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { IHom0201MState, IProjectState, IInquiryCndsState } from '../../models/hom/hom0201m_model';
  
const initialState: IHom0201MState = {
    projectList : [],      // 프로젝트목록

    inquiryCnds: {
        conditionCusnm : '',    // 기관명
        conditionPjNm  : '',    // 프로젝트명
    },                          // 조회조건

    pageSize : 20,          // 페이징사이즈
    current : 0,            // 현재페이지
}

export const hom0201m_Slice = createSlice({
    name: "hom0201m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState});
        },
        setProjectList: (state, action:PayloadAction<IProjectState[]>) => {
            state.projectList = action.payload;
        },
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setPageSize: (state, action:PayloadAction<number>) => {
            state.pageSize = action.payload;
        },
        setCurrent: (state, action:PayloadAction<number>) => {
            state.current = action.payload;
        },
    },
});

export default hom0201m_Slice.reducer;
export const Hom0201mAction  = hom0201m_Slice.actions;
export const Hom0201mReducer = hom0201m_Slice.reducer;